export const faqs = [

        {
            "title": "What is CreateX?",
            "description": "CreateX is a 30-day challenge where participants bring their ideas to life through hands-on projects. It’s all about problem-solving, creativity, and innovation!"
        },
        {
            "title": "Who can participate in CreateX?",
            "description": "All students with a passion for creating, regardless of experience or technical background, are welcome to participate. Just bring your ideas and your enthusiasm to learn!"
        },
        {
            "title": "How do I sign up?",
            "description": "You can register via our event's Unstop Posting, which is linked here: {Link}"
        },
        {
            "title": "What kind of projects can I work on?",
            "description": "Projects are to be based on problem statements that will be available on our website or you can choose to submit your own problem statement as a Student Innovation."
        },
        {
            "title": "Do I need a team, or can I participate solo?",
            "description": "A team of 2 - 4 members is needed to participate. All the members of a team must be from the same college."
        },
        {
            "title": "Is there any fee to participate?",
            "description": "Yes, there is a participation fee of Rs.100 per person. This fee will be required to be submitted during the registration process. Participation fees go towards ensuring a great event experience for all the participants."
        },
        {
            "title": "What will I need to complete my project?",
            "description": "Basic tools and materials may be needed depending on your project idea. We encourage creativity with available resources, and we'll provide guidance along the way if you need help."
        },
        {
            "title": "What’s at the end of the 30 days?",
            "description": "The challenge wraps up with a Technical Exhibition where participants showcase their completed projects. It’s a great chance to demonstrate your work, gain recognition, and inspire others!"
        },
        {
            "title": "Are there prizes?",
            "description": "Absolutely! We have an exciting prize pool for the top projects. To see the prize pool structure, refer to the official Rulebook of CreateX 2024."
        },
        {
            "title": "How do I stay updated on event announcements?",
            "description": "Follow us on social media and use our event hashtag #CreateToInnovate for all updates. Important announcements will also be sent to registered participants by email and team leaders will be added to a common announcement WhatsApp channel."
        },
        {
            "title": "Will I receive guidance or support during the challenge?",
            "description": "Yes! We’ll provide periodic check-ins to keep you on track. Our mentors will also be available to answer any questions and offer tips."
        },
        {
            "title": "How will projects be judged?",
            "description": "Projects will be evaluated based on innovation, feasibility, impact, and presentation during the exhibition. Judges will look at how well your project solves a problem or brings value. Refer to the Rulebook of CreateX 2024 for judging criteria."
        },
        {
            "title": "How do I contact the organizers if I have questions?",
            "description": "Feel free to reach out to us via email or through our social media channels. We’re here to help you every step of the way!"
        },
        {
            "title": "Can I submit more than one project?",
            "description": "Participants or teams are allowed to submit only one project per team. Focus on delivering a high-quality project with your best ideas!"
        },
        {
            "title": "Are there any restrictions on project materials?",
            "description": "Projects should use safe, non-hazardous materials. If you’re uncertain about specific materials, feel free to contact the organizers for approval."
        },
        {
            "title": "Can I change my project idea after starting?",
            "description": "Yes, minor adjustments to your idea are allowed, but you must inform the organizers. Major changes after registration may need approval to ensure they fit the event guidelines."
        },
        {
            "title": "What if my team is unable to complete the project?",
            "description": "We encourage all teams to make progress, but if you encounter challenges, our mentors are here to help. Even partial projects are valuable and can be presented at the exhibition."
        },
        {
            "title": "Will there be networking opportunities?",
            "description": "Yes! The exhibition provides a great opportunity to meet industry professionals, mentors, and fellow participants."
        },
        {
            "title": "Is participation mandatory in the final exhibition?",
            "description": "Yes, to be eligible for prizes and recognition, teams must present their projects at the final exhibition. This is the culmination of CreateX, where everyone’s hard work is celebrated."
        },
        {
            "title": "Are there specific deadlines for project checkpoints?",
            "description": "Yes, there will be designated checkpoints throughout the 30 days. These are designed to help teams stay on track and receive feedback from mentors."
        },
        {
            "title": "Will I receive a certificate for participating?",
            "description": "Yes, all participants will receive a certificate of participation, with special certificates for winning teams and notable projects."
        },
        {
            "title": "Can alumni or faculty members participate?",
            "description": "CreateX is open only to current students. However, alumni and faculty are welcome to join as mentors, judges, or attend the final exhibition to support participants."
        }
    ];
